import { createAction, handleActions } from 'redux-actions';

const SET_MIL_TYPE = 'supporSytem/SET_MIL_TYPE';
const SET_MIL_NAME = 'supporSytem/SET_MIL_NAME';

export const setMilType = createAction(SET_MIL_TYPE);
export const setMilName = createAction(SET_MIL_NAME);


const supportSystem = handleActions(
  {
    [SET_MIL_TYPE]: (state, action) => {
      return {
        ...state,
        milType: action.payload,
      };
    },
    [SET_MIL_NAME]: (state, action) => {
      return {
        ...state,
        milName: action.payload,
      };
    },
  },
  {
    milType: '',
    response: [],
    options: [],
  }
);

export default supportSystem;
